module.exports = __webpack_public_path__ + "static/media/Admin-space.2631b5d1.gif";